(function (WishlistLS, $) {

    var $wishlistButton = $('.wishlist-btn');
    var $wishlistTile = $('.wishlist-tile-container');
    var $wishlistItemCount = $('.wishlist-item-count');
    var $wishlistItemCounts = $('.wishlist-item-counts');
    var numProductTiles = $wishlistTile.length;
    var wishlist = localStorage.getItem('user_wishlist') || [];
    if (wishlist.length > 0) {
      wishlist = JSON.parse(localStorage.getItem('user_wishlist'));
    }
  
    /*
     * Update button to show current state (gold for active)
     */   
    var animateWishlist = function (self) {
      $(self).toggleClass('is-active');
    };
  
    /*
     * Add/Remove selected item to the user's wishlist array in localStorage
     * Wishlist button class 'is-active' determines whether or not to add or remove
     * If 'is-active', remove the item, otherwise add it
     */   
    var updateWishlist = function (self) {
      var productHandle = $(self).attr('data-product-handle');
      var isRemove = $(self).hasClass('is-active');
      /* Remove */
      if (isRemove) {
        var removeIndex = wishlist.indexOf(productHandle);
        
        wishlist.splice(removeIndex, 1);
        localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
        $.toastr.success('Product removed fom wish list', {position: 'right-bottom'});
        displayOnlyWishlistItems()
      }
      /* Add */ 
      else {
        wishlist.push(productHandle);
        localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
        $.toastr.success('Product added to wish list', {position: 'right-bottom'});
      }
    };
  
    /*
     * Loop through wishlist buttons and activate any items that are already in user's wishlist
     * Activate by adding class 'is-active'
     * Run on initialization
     */   
    var activateItemsInWishlist = function () {
      $wishlistButton.each(function () {
        var productHandle = $(this).attr('data-product-handle');
       
        if (wishlist.indexOf(productHandle) > -1) {
          $(this).addClass('is-active');
        }
      });
    };
  
    /*
     * Loop through product titles and remove any that aren't a part of the wishlist
     * Decrement numProductTiles on removal
     */   
    var displayOnlyWishlistItems = function () {
      $wishlistTile.each(function () {
        var productHandle = $(this).attr('data-product-handle');
        console.log(productHandle)
        if (wishlist.indexOf(productHandle) === -1) {
          $(this).remove();
          numProductTiles--;
         
        }
      });
    };
  
    /*
     * Check if on the wishlist page and hide any items that aren't a part of the wishlist
     * If no wishlist items exist, show the empty wishlist notice
     */   
    var loadWishlist = function () {
      if (window.location.href.indexOf('pages/wish-list') > -1) {
        displayOnlyWishlistItems();
        $('.wishlist-loader').fadeOut(2000, function () {
          $('.wishlist-grid').removeClass('hide');
          $('.wishlist-hero').removeClass('hide');
          if (numProductTiles == 0) {
            $('.wishlist-grid--empty-list').removeClass('hide');
            $('.btndiv').addClass('hide');
          } else {
            $('.wishlist-grid--empty-list').hide();
            $('.wishlist-tile-container').removeClass('hide');
            $('.btndiv').removeClass('hide');
          }
        });
      }
    };
  
    /**
     * Display number of items in the wishlist
     * Must set the $wishlistItemCount variable
     */
    var updateWishlistItemCount = function () {
      if (wishlist) {
        $wishlistItemCount.text(wishlist.length);
        $wishlistItemCounts.text(wishlist.length+' Item(s)');
      }
    };
  
    var bindUIActions = function () {
      $wishlistButton.click(function (e) {
        e.preventDefault();
        updateWishlist(this);
        animateWishlist(this);
        updateWishlistItemCount();
      });
    };
  
    WishlistLS.init = function () {
      bindUIActions();
      activateItemsInWishlist();
      loadWishlist();
      updateWishlistItemCount();
    };
  
  }(window.WishlistLS = window.WishlistLS || {}, jQuery, undefined));